import { getProductInventory } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useSWRProductInventory = (inventoryId: string | null) => {
  const {
    data: inventory,
    isLoading,
    error,
    mutate,
  } = useSWR(inventoryId ? `productInventory-${inventoryId}` : null, () => getProductInventory(inventoryId as string), {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    inventory,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRProductInventory;
